import React from "react";
import axios from "axios";
import { useLoaderData, useNavigate } from "react-router";
import { Card, Row, Col, Container, Button, Badge } from "react-bootstrap";
import { renderLoadingProgressToast } from "components/shared/Toasts";
import { useAuth } from "components/shared/AuthProvider";
import Seo from "components/shared/Seo";
import styled from "styled-components";

const PlanDetail = styled.div`
    height: 5rem;
`;

export async function loader_for_anonymous_user() {
    const data = await renderLoadingProgressToast(
        axios.get("subscription/plans")
    ).then((response) => response.data);
    return data;
}

export async function loader_for_login_user() {
    const data = await renderLoadingProgressToast(
        axios.get("subscription/plans/upgrade")
    ).then((response) => response.data);
    return data;
}

const Pricing = () => {
    const { categories } = useLoaderData();
    const nav = useNavigate();
    const { isAuthenticated } = useAuth();

    const onCheckout = (plan_type_id) => {
        const checkoutUrl = `/subscription/checkout/${plan_type_id}`;
        if (isAuthenticated) {
            nav(checkoutUrl);
        } else {
            nav("/account/signin", {
                state: { returnUrl: checkoutUrl },
            });
        }
    };

    return (
        <Container>
            <Seo title="Plans & Pricing" />
            <h1 className="text-center my-3">Plans & Pricing</h1>
            <Row className="gap-4 d-flex justify-content-center">
                {categories.map((category, idx) =>
                    category.billing_cycles.map((b) => (
                        <Col
                            key={`${category.name}_${b.interval_unit}`}
                            md="5"
                            lg="4"
                        >
                            <Card
                                border="dark"
                                data-testid={`${category.name}_${b.interval_unit}`}
                            >
                                <Card.Header>{`${category.name} (${b.interval_unit})`}</Card.Header>
                                <Card.Body>
                                    <PlanDetail>
                                        <div>
                                            <b
                                                data-testid={`${category.name}_${b.interval_unit}_price`}
                                            >{`${b.currency} ${b.price} per ${b.interval_unit}`}</b>
                                            {b.original_price && (
                                                <div className="d-flex gap-2">
                                                    <s>{`${b.currency} ${b.original_price}`}</s>
                                                    <Badge
                                                        bg="danger"
                                                        data-testid={`${category.name}_${b.interval_unit}_discount`}
                                                    >
                                                        {(
                                                            -100 *
                                                            (1 -
                                                                b.price /
                                                                    b.original_price)
                                                        ).toPrecision(2)}
                                                        %
                                                    </Badge>
                                                </div>
                                            )}
                                        </div>
                                    </PlanDetail>
                                    <div>Features:</div>
                                    <ul>
                                        {category.features.map(
                                            (feature, idx) => (
                                                <li key={idx}>{feature}</li>
                                            )
                                        )}
                                    </ul>
                                    <div className="d-grid">
                                        <Button
                                            disabled={b.disabled}
                                            data-testid={`${category.name}_${b.interval_unit}_checkout`}
                                            variant="primary"
                                            onClick={() =>
                                                onCheckout(b.plan_type_id)
                                            }
                                            type="submit"
                                        >
                                            {b.disabled
                                                ? "Current Plan"
                                                : "Subscribe"}
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                )}
            </Row>
        </Container>
    );
};

export default Pricing;
